import { Box, CircularProgress } from '@mui/material';

export function Spinner(props) {
  return (
    <Box
      data-testid="spinner"
      sx={{
        height: '100%',
        ...props.sx,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
}
